<template>
    <div id="Home">
        <HomeBanner></HomeBanner>
        <section id="home-statistics-map">
            <h1 class="h1 center">海洋廢棄物統計</h1>
            <suspense>
                <template #default>
                    <StatisticsMap></StatisticsMap>
                </template>
                <template #fallback>
                    <div>Loading...</div>
                </template>
            </suspense>
        </section>
        <section id="home-activity-carousel">
            <h1 class="h1 center">最新淨灘活動</h1>
            <suspense>
                <template #default>
                    <HomeActivityCarousel></HomeActivityCarousel>
                </template>
                <template #fallback>
                    <div>Loading...</div>
                </template>
            </suspense>
            <router-link
                class="activity-button"
                tabindex="0"
                role="button"
                :to="{ name: 'Activities' }"
                >查詢其他淨灘活動</router-link
            >
        </section>
    </div>
</template>
<script>
export default {
    name: 'Home',
}
</script>
<script setup>
import { defineAsyncComponent } from 'vue'
import { HomeBanner } from '@/components/ch'
const StatisticsMap = defineAsyncComponent(() =>
    import('@/components/ch/StatisticsMap.vue')
)
const HomeActivityCarousel = defineAsyncComponent(() =>
    import('@/components/ch/HomeActivityCarousel.vue')
)
</script>
<style lang="scss" scoped>
#home-activity-carousel {
    padding-bottom: 80px;
    background-color: $theme3;
    h1 {
        color: $white;
    }
    .activity-button {
        @include largeButtonStyle($theme3, $theme1);
    }
    @media screen and (max-width: 767px) {
        .activity-button {
            margin-top: 50px;
        }
    }
}
</style>
